module.exports = __webpack_public_path__ + "static/img/no.c9073e86.png";